import {getAgentSignature} from '../../helpers/getAgentSignature';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';
import {
    emailHeaderCompanyLogo,
    afterSaleGreeting,
    afterSaleIntroVideo,
    aboutAmplify,
} from '../../helpers/commonEmailComponents';

export default function afterSaleGINonblend(params: QuoteTemplateParams) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {name, face_amount, monthly_premium} = params;

    return `
${emailHeaderCompanyLogo}
<p>Dear ${highlightYellow(name)},</p>
${afterSaleGreeting}
${afterSaleIntroVideo}
<p><strong>In summary of what we've discussed, our life insurance policies can provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Life insurance protection for the rest of life</span></li>
</ol>
<p><strong>Life insurance plan summary for ${highlightYellow(name)}</p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        face_amount,
    )}</span><span style="font-weight: 400;"> life insurance protection for the rest of life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthly_premium,
    )} per month</span></li>
</ul>
${aboutAmplify}
<p><strong>Also included in this email you will find:</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Life Insurance Company Brochure</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;"><a href="https://amplify-strapi-production.s3.us-west-1.amazonaws.com/Amplify_Carriers_and_Partners_e8d0162623.pdf">List of Amplify Carriers & Partners</a></span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;"><a href="https://amplify-strapi-production.s3.us-west-1.amazonaws.com/Life_Insurance_Buyers_Guide_36e3c43ade.pdf">Life Insurance Buyers Guide</a></span></li>
</ul>
<p><span style="font-weight: 400;">Looking forward to speaking with you again and helping you get the coverage and savings you need for peace of mind!</span></p>
<p><span style="font-weight: 400;">Best,</span></p>
${getAgentSignature()}
	`;
}
